import axios from "../utils/axios";
import defaultAxios from "axios"
let AppApi = {
   addBrand: (data) => axios({
      url: '/v1/admin/brand',
      method: 'post',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   addSlider: (data) => axios({
      url: '/v1/admin/landing-page/slider',
      method: 'post',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   getIpAddress: (domain) => {
      let baseURL = `https://dns.google/resolve?name=${domain}&type=A`
      return defaultAxios({
         url: baseURL,
         method: 'get',
      })
   },
   updateProfile: (data) => axios({
      url: '/v1/admin/profile',
      method: 'patch',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   getProfile: (data) => axios({
      url: '/v1/admin/profile',
      method: 'get',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   updateSettings: (data) => axios({
      url: '/v1/admin/settings',
      method: 'patch',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   updateBrand: (data) => axios({
      url: '/v1/admin/brand',
      method: 'patch',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   updateSlider: (data, sliderId) => axios({
      url: '/v1/admin/landing-page/slider/' + sliderId,
      method: 'put',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   getBrands: (data) => axios({
      url: '/v1/admin/brand',
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   getPendingOrders: (data) => axios({
      url: '/v1/admin/order/pending/count',
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   updateBrandsListOrder: (data) => axios({
      url: '/v1/admin/brand-order',
      method: 'patch',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   addCategory: (data) => axios({
      url: '/v1/admin/category',
      method: 'post',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   addSubcategory: (data, id) => axios({
      url: '/v1/admin/category/' + id,
      method: 'post',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   getSubcategories: (id) => axios({
      url: '/v1/admin/category/' + id,
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   updateCategory: (data) => axios({
      url: '/v1/admin/category',
      method: 'patch',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   updateSubCategory: (data, category, id) => axios({
      url: '/v1/admin/category/' + category + "/" + id,
      method: 'put',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   updateOrderById: (id, data) => axios({
      url: `/v1/admin/order/${id}`,
      method: 'put',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   getOrderHistory: (id) => axios({
      url: `/v1/admin/order/history/${id}`,
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   getCategories: (data) => axios({
      url: '/v1/admin/category',
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   getUsers: (data) => axios({
      url: '/v1/admin/users',
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   updateCategoriesListOrder: (data) => axios({
      url: '/v1/admin/category-order',
      method: 'patch',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   updateSubcategoriesListOrder: (data) => axios({
      url: '/v1/admin/subcategory-order',
      method: 'patch',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   appLandingPage: (data) => axios({
      url: '/v1/app/landing-page',
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
         website: "localhost:3000"
      },
   }),

   addLocation: (data) => axios({
      url: '/v1/admin/location',
      method: 'post',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   updateLocation: (data) => axios({
      url: '/v1/admin/location',
      method: 'put',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   tawkTo: (data) => axios({
      url: '/v1/admin/plugins/tawk-to',
      method: 'post',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   liveChatINC: (data) => axios({
      url: '/v1/admin/plugins/live-chat-inc',
      method: 'post',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   googleAnalytics: (data) => axios({
      url: '/v1/admin/plugins/google-analytics',
      method: 'post',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   googlSearch: (data) => axios({
      url: '/v1/admin/plugins/google-search',
      method: 'post',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   tiktokPixel: (data) => axios({
      url: '/v1/admin/plugins/tiktok-pixel',
      method: 'post',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   metaPixel: (data) => axios({
      url: '/v1/admin/plugins/meta-pixel',
      method: 'post',
      data,
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),
   recentOrders: (data) => axios({
      url: '/v1/admin/orders?status=PENDING',
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),



   // getMyPurchasedPackages: async () => {
   //     return await axios({
   //         url: "/v1/user/packages/purchased",
   //         method: "get",
   //         headers: {
   //             Authorization: "Bearer " + localStorage.getItem("token"),
   //         },
   //     });
   // },
}

export default AppApi
